import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoints';

export const EMPTY_END_TO_END_MAP = { positions: {}, edges: [] };

export function emptyEndToEndMap() {
  return EMPTY_END_TO_END_MAP;
}

export function newEndToEndConnectorId() {
  return `temp-${Date.now()}`;
}

export function normalizeEndToEndMap(payload) {
  const positions =
    payload?.positions && typeof payload.positions === 'object' && !Array.isArray(payload.positions)
      ? payload.positions
      : {};
  const edges = Array.isArray(payload?.edges) ? payload.edges : [];
  return {
    positions,
    edges: edges.map((edge) => ({
      id: String(edge?.id ?? '').trim(),
      source: String(edge?.source ?? '').trim(),
      target: String(edge?.target ?? '').trim(),
      sourceHandle: String(edge?.sourceHandle ?? '').trim() || null,
      targetHandle: String(edge?.targetHandle ?? '').trim() || null,
    })),
  };
}

export async function fetchCycleEndToEndMap(cycleId) {
  const response = await axiosInstance.get(API_ENDPOINTS.getCycleEndToEndMap(cycleId));
  if (response?.data?.success !== true) {
    throw new Error('Failed to load end-to-end map');
  }
  return normalizeEndToEndMap(response.data);
}

export async function saveCycleEndToEndMap(cycleId, map) {
  const normalized = normalizeEndToEndMap(map);
  const response = await axiosInstance.put(API_ENDPOINTS.saveCycleEndToEndMap(cycleId), {
    positions: normalized.positions,
  });
  if (response?.data?.success !== true) {
    throw new Error(response?.data?.error || 'Failed to save end-to-end map');
  }
  return normalizeEndToEndMap(response.data);
}

export function mapFromCanvas(nodes, edges) {
  const positions = {};
  (Array.isArray(nodes) ? nodes : []).forEach((node) => {
    if (!node?.id || !node?.position) return;
    positions[node.id] = {
      x: Number(node.position.x),
      y: Number(node.position.y),
    };
  });
  return {
    positions,
    edges: (Array.isArray(edges) ? edges : []).map((edge) => ({
      id: String(edge?.id ?? '').trim(),
      source: String(edge?.source ?? '').trim(),
      target: String(edge?.target ?? '').trim(),
      sourceHandle: String(edge?.sourceHandle ?? '').trim() || null,
      targetHandle: String(edge?.targetHandle ?? '').trim() || null,
    })),
  };
}
